import { NgModule } from '@angular/core';
import { GtmGgCartRemoveEntrySuccessEventBuilder } from './gtm-gg-cart-remove-entry-success-event.builder';

@NgModule({})
export class GtmGgCartRemoveEntrySuccessEventModule {
  constructor(_gtmGgCartRemoveEntrySuccessEventBuilder: GtmGgCartRemoveEntrySuccessEventBuilder) {}
}
